import { create } from './deferred';
import { CommonApis } from '@eureka/services/src/apis/common.api'

export enum EurekaProduct {
    /**
     * Eureka
     */
    GENERAL = 'GENERAL',
    /**
     * 材料
     */
    MATERIAL = 'MATERIAL'
}

export enum EUploadCode {
    /**
     * IP范围
     */
    IPForbidden = 90113001,
    /**
     * 管理员
     */
    AdminForbidden = 90113002
}

// 模块名称
export enum EurekaModule {
    NOVELTY_CHECK = 'novelty_check', // 技术想法查新
    AI_DISCLOSURE = 'ai_disclosure', // 交底书助手
    ROADMAP = 'roadmap', // 行业技术路线
    SUBSTANCE_SEARCH = 'substance_search', // 物质探究
    PROPERTY_SEARCH = 'property_search', // 材料性能探索
    METAL_SEARCH = 'metal_search', // 成分搜索
    STRUCTURE_SEARCH = 'structure_search', // 结构式检索
    WORKFLOW_SEARCH = 'workflow_search', // 材料合成工艺
    MATERIAL_MIND = 'material_mind', // 材料技术方案探索
    RESEARCH = 'research', // 技术预研报告
    MIND = 'mind', // 技术方案探索
    FMEA = 'fmea', // 技术失效分析
    WORKSPACE = 'workspace' // 工作空间
}

// TODEL 备份着对比使用，control稳定后删除
// export interface IControl {
//     /**
//      * 用户产品
//      */
//     product: EurekaProduct,
//     /**
//      * 邀请活动弹窗权限
//      */
//     activity: boolean,
//     /**
//      * Chat权限
//      */
//     chat: boolean,
//     /**
//      * 立项权限
//      */
//     project: boolean,
//     /**
//     * 结构式
//     */
//     material_structure: boolean,
//     /**
//      * 技术想法查新
//      */
//     disclosure_check: boolean,
//     /**
//      * 是否是免费用户
//      */
//     freemium: boolean
//     /**
//      * 是否是试用用户
//      */
//     trial: boolean
//     /**
//     * 下载权限
//     */
//     download: boolean,
//     /**
//      * 上传权限
//      */
//     upload: boolean,
//     /**
//      * 上传被禁的原因（IP范围/管理员）
//      * 只有上传禁止才会有这个字段
//      */
//     upload_code?: EUploadCode,
//     /**
//      * 基于{company}组织的策略，当前IP范围内不允许上传文件
//      * 只有上传禁止才会有这个字段
//      */
//     company?: string[],
//     /**
//      * 当前选择的首页模块
//      */
//     selected_module: EurekaSelectedModule,
//     /**
//      * 是否有AIR功能
//      */
//     air_feature: boolean,
//     /**
//      * 用户是否处于AIR产品模式。
//      * 如果用户是材料，即使选择了AIR，也不算AIR产品模式，算材料产品模式
//      */
//     is_air_product: boolean
//     /**
//      * 是否是material产品
//      */
//     is_material_product: boolean
//     /**
//      * 是否是standard产品
//      */
//     is_standard_product: boolean
//     /**
//      * 是否试用到期
//      */
//     is_first_login_after_try_end: boolean
//     /**
//      * 试用到期天数
//      */
//     try_package_left_days: number
// }

// 接口返回的字段类型（### 严格与接口一致 ###）
export interface IBaseControl {
    /* =============== 基础权限 =============== */
    /**
     * 公司详情权限
     */
    company_profile: boolean,
    /**
    * 下载权限
    */
    download: boolean,
    /**
     * 上传权限
     */
    upload: boolean,
    /**
     * 邀请活动弹窗权限
     */
    activity: boolean,
    /**
     * 上传被禁的原因（IP范围/管理员）
     * 只有上传禁止才会有这个字段
     */
    upload_code?: EUploadCode,
    /**
     * 基于{company}组织的策略，当前IP范围内不允许上传文件
     * 只有上传禁止才会有这个字段
     */
    company?: string[],
    /**
     * 首页权限
     */
    ip_tab: EurekaModule[],
    material_tab: EurekaModule[],
    air_tab: EurekaModule[],
    insights_tab: EurekaModule[],
    /**
     * 是否是免费用户
     */
    freemium: boolean
    /**
     * 是否是试用用户
     */
    trial: boolean
    /**
     * 是否需要引导
     */
    need_guide: string[],
    /**
     * 是否需要收集用户姓名手机等信息
     */
    is_skip_collection_user_info: boolean
    /**
     * 是否试用到期
     */
    is_first_login_after_try_end: boolean
    /**
     * 试用到期天数
     */
    try_package_left_days: number
    /**
     * 技术信息问答
     */
    seek: boolean
    /**
     * 试用已到期的产品
     */
    expired_packages: string[]
    /**
     * 是否弹出Eureka合并升级引导提示
     */
    template_upgrade_notice: boolean
}

// 字段映射层
export interface IControl extends IBaseControl {
    /**
     * 是否处于material产品模式
     */
    isMaterial: boolean
    /**
     * 是否处于IP模式
     */
    isIP: boolean
}

export const controlDeferred = create<IControl>();

export const getControl = () => CommonApis.getGlobalControl().then(res => {
    const materialTab = res.material_tab;
    const isMaterial = materialTab?.length > 0;
    const isIP = !isMaterial && res.ip_tab?.length > 0;
    controlDeferred.resolve({
        ...res,
        isMaterial,
        isIP,
    })
    return res;
})

getControl();
